<template>
  <div class="spe">
   <span class='title'>{{list.name}}</span>
   <div class="head-box">
        <swiper ref="mySwiper" :options="swiperOptions" :auto-play="true">
            <swiper-slide v-for="item in list.carousel_image" :key="item">
                <img :src="item" alt=""/>
            </swiper-slide>
            <div class="swiper-button-prev"
             slot="button-prev"></div>
            <div class="swiper-button-next"
             slot="button-next"></div>
      </swiper>
       <div class="head-box-right">
           <h4>{{list.name}} </h4>
           <!-- <div class="right-box">
             产品编号：88888888 <br>
             价格：xxxx元 <br>
             预计周期：xx天 
           </div>
           <div class="btns">
               <button class="book">实验委托书</button>
               <button class="apply" @click="dialog()">申请服务</button>
           </div> -->
       </div>
   </div>
   <div class="tab">
       <div class="tab-head">
           <a v-for="(item,index) in lists" :key="index" :class="{active:index == currentIndex}" @click="toggerIndex(index)">{{item.title}}</a>
       </div>
       <div class="tab-main">
            <div class="tab-main-box" v-if="currentIndex == 0">
                <div v-html="list.description">
                    <span>{{list.description}}</span>
                </div>
            </div>
            <div class="tab-main-box" v-if="currentIndex == 1">
                <div v-html="list.process">
                    <span>{{list.process}}</span>
                </div>
            </div>
            <div class="tab-main-box" v-if="currentIndex == 2">
                <div v-html="list.sample">
                    <span>{{list.sample}}</span>
                </div>
            </div>
            <div class="tab-main-box" v-if="currentIndex == 3">
                <div v-html="list.case">
                    <span>{{list.case}}</span>
                </div>
            </div>
       </div>
   </div>
   <div class="dialog" @click="dispear()" v-if="flag">
       <div class="white">
           1111
       </div>
   </div>
  </div>
</template>

<script>
export default {
  props:['list'],
  data(){
      return{
        currentIndex: '',
        flag:false,
        swiperOptions: {
            grabCursor: true,
            autoplay: {
            delay: 3000,
            disableOnInteraction: false,
            },
            loop: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            }
        },
        lists:[{
            title:'产品描述'
        },{
            title:'服务流程'
        },{
            title:'产品要求'
        },{
            title:'案例展示'
        }]
      }
  },
  methods: {
      toggerIndex(index){
        this.currentIndex = index
      },
      dialog(){
          this.flag = true
      },
      dispear(){
          this.flag = false
      }
  }
}
</script>

<style lang="less" scoped>
.swiper-button-next,.swiper-button-prev{
    width: 30px;
    height: 30px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(218,218,218,0.5); 
    border-radius: 50%;
}
.swiper-button-next{
    margin-right: 20px;
}
.swiper-button-next:after,.swiper-button-prev:after{
    font-size: 18px;
    color: #b3b3b3;
}
.title{
font-size: 24px;
color: #333333;
}
.head-box{
    width: 100%;
    height: 256px;
    display: flex;
    margin-top: 28px;
    img{
        width: 350px;
        height: 256px;
        border:1px solid #ccc;
    }
    .head-box-right{
        margin-left: 36px;
        h4{
            width: 467px;
            height: 31px;
            font-size: 24px;
            font-weight: 700;
            color: #333333;
        }
        .right-box{
            margin-top: 15px;
            width: 431px;
            height: 154px;
            font-size: 14px;
            color: #666666;
            line-height: 28px;
        }
        .btns{
            .book{
                width: 183px;
                height: 40px;
                background: #fff4d9;
                border: 1px solid #ffbb00;
                border-radius: 3px;
                font-size: 14px;
                font-weight: 700;
                color: #ffbb00;
            }
            .apply{
                width: 136px;
                height: 40px;
                background: #ffbb00;
                border: 1px solid #ffbb00;
                border-radius: 3px;
                margin-left: 16px;
                font-size: 14px;
                font-weight: 700;
                color: #003871;
            }
        }
    }
}
.tab{
    margin-top: 37px;
    margin-bottom: 20px;
    .tab-head{
        width: 876px;
        height: 48px;
        background: #f5f5f5;
        border: 1px solid #dddddd;
        display: flex;
        justify-content: space-around;
        a{
            font-size: 16px;
            font-weight: 600;
            color: #333333;
            margin-top: 15px;
            text-decoration-line: none;
        }
        .active{
          color:#A52A2A;
       }
    }
    .tab-main{
        width: 876px;
        font-size: 18px;
        text-align: left;
        line-height: 28px;
        .tab-main-box{
             margin-top: 30px;
            span{
                width: 876px;
                height: 379px;
                font-size: 14px;
                text-align: left;
                color: #666666;
                line-height: 28px; 
            }
            p{
                font-size:14px;
                line-height: 28px;
            }
            .download{
                width: 876px;
                height: 48px;
                background: #ffffff;
                box-shadow: 0px 0px 14px 0px rgba(211,211,211,0.5); 
                display: flex;
                justify-content: space-between;
                padding:14px 25px;
                margin-top: 20px;
                a{
                    font-size: 12px;
                    text-decoration: underline;
                    color: #003871;
                    line-height: 16px;
                }
            }
        }
    }
}
// .dialog{
//     position: fixed;
//     left:0px;
//     top:0px;
//     width: 100vw;
//     height:100vh;
//     background: rgba(0,0,0,.3);
//     z-index:1;
//     .white{
//         background: #fff;
//         position: fixed;
//         left:50%;
//         top:50%;
//         transform: translate(-50%,-50%);
//         width: 876px;
//         height: 400px;
//         background: #fbfbfb;
//         border: 1px solid #dddddd;
//         border-radius: 6px;
//     }
// }
</style>